import { render, staticRenderFns } from "./InfoProblema.vue?vue&type=template&id=721a3328&"
import script from "./InfoProblema.vue?vue&type=script&lang=js&"
export * from "./InfoProblema.vue?vue&type=script&lang=js&"
import style0 from "./InfoProblema.vue?vue&type=style&index=0&id=721a3328&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports